import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { compose, mapProps } from 'recompose'
import * as R from 'ramda'
import {TableCell} from 'react-toolbox/lib/table'
import Dropdown from 'react-toolbox/lib/dropdown'

import {
  ROLE_OPTIONS,
} from './constants'

import {
  enhance,
  ViewTable,
  ModifyTable
} from 'containers/Admin/Table/index'

import styles from './styles.scss'

const dropdownSource = R.compose(
  R.map(value => ({value, label: value})),
  R.values
)(ROLE_OPTIONS)

const DropdownRole = ({disabled ,value, onChange}) => {
  return (
    <Flex justify='flex-end'>
      <div class={styles.userRoleSelection}>
        <Dropdown
          auto
          disabled={disabled}
          theme={styles}
          onChange={onChange}
          value={value}
          source={dropdownSource}
        />
      </div>
    </Flex>
  )
}

const addDropdownToSource = (onChange, selectable) => R.map(value => ({
  ...value,
  action: (
    <DropdownRole
      disabled={!selectable}
      value={ROLE_OPTIONS[value.role]}
      onChange={(role) => onChange(value, role)}
    />
  )
}))

const tableHeadContent = {
    name: (<TableCell key={0}>Name</TableCell>),
    username: (<TableCell key={1}>Username</TableCell>),
    email:(<TableCell key={2}>Email</TableCell>),
    action: (<TableCell key={3}>Access Level</TableCell>)
}

const withModelProps = mapProps(
    ({ selectable, onEdit, source, ...rest }) => ({
        ...rest,
        source: addDropdownToSource(onEdit, selectable)(source),
        selectable,
        tableHeadContent
    })
)

const withStyle = CSSModules(styles)
const StyledViewTable = withStyle(ViewTable)
const StyledModifiedTable = withStyle(ModifyTable)

export default compose(
  withModelProps,
  enhance
)(StyledViewTable, StyledViewTable)
